<template>
  <div id="newEmailCampaignContainer">
    <email-campaign
      v-on:save="handleOnSave"
      v-on:cancel="handleCancel"
     />
  </div>
</template>

<script>
import EmailCampaign from './EmailCampaign'
export default {
  components: {
    EmailCampaign
  },
  methods: {
    handleOnSave (emailCampaign) {
      this.$router.push({ name: 'email_campaigns_path' })
      this.$flash({
        showClose: true,
        message: `Saved Email Campaign ${emailCampaign.name}`,
        type: 'success',
        duration: 2000
      })
    },
    handleCancel () {
      this.$router.push({ name: 'email_campaigns_path' })
    }
  }

}
</script>
